export const css = {
    root: '_3uwLq_VJ',
    grouphead: '_1VPn1OHi',
    actions: '_1G6IA486',
    group: '_3M3ayz1z',
    progress: '_1r-6lP47',
    toc: '_2A7_IlPU',
    resource: '_3ImQOjzJ',
    competencyConnection: '_2w0gvrXk',
    topicBlock: '_1H0pMgCU',
    titleBlock: '_2SXYff3t',
    title: '_1HAKYqTm',
    close: '_Prz268y',
    deck: '_2wi5bI2X',
    refTitleBlock: 'ItAy5CC4',
    complete: 'mI46keWS',
    incomplete: '_3EP6tik2',
    refTitle: 'an787bBy',
    fragment: '_1gdSvR9n',
    readButton: '_50r5QqBQ',
    legend: 'DYlnR4RV',
    legendText: 'YGr14e2Z',
    action: '_18mzOV66',
    actionIcon: '_34DcRFv2',
    actionText: 'g9REE_hq',
    activitycontent: '_15GhEj3G',
    videolink: 'Y4bq05Zv',
    cialink: '_2XJwIhM3',
    ciacontent: '_1RSh0BLf',
    resourcecontent: '_2q7Ch0Bq',
    resourcelink: '_2IJaCFkh',
    scorePill: '_1w1jnKIq',
    topicAudio: '_3Z6jw_4S',
    ' _key': 'ascm-theme/ascm/book-widgets/topicgroup'
};
export default css;
